import React from 'react';
import { Transform } from 'stream';

export default class HomePage extends React.Component {
  render() {
    return (
      <div className="homepage-topdiv">
        <div className="help">Help!?</div>
        <div className="ouch">Ouch!</div>
        <div className="title1">Hello, I'm</div>
        <div className="title2">Shaun Tung</div>
        <div className="title3">
          I HATE BEES, BUT I LOVE BEEAUTIFUL SOLUTIONS
        </div>
        <div className="thisStings">This stings</div>
        <div className="honeyImHome">Honey, I'm home</div>
      </div>
    );
  }
}
